import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
const GLAccount = types.model('GLAccount', {
  externalId: types.maybeNull(types.string),
  accountName: types.maybeNull(types.string),
  accountType: types.maybeNull(types.string),
  lastUpdatedAt: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  number: types.maybeNull(types.string),
  type: types.maybeNull(types.string)
});
const UtilityGlAccountsUnit = types.model('UtilityGlAccountsUnit', {
  propertyUtilityLivableId: types.maybeNull(types.string),
  glAccountExternalId: types.maybeNull(types.string),
  accountsPayableGlAccountExternalId: types.maybeNull(types.string)
});
export const glCodeSetupModel = types.model('glCodeSetupModel', {
  isLoaded: types.optional(types.boolean, false),
  glAccounts: types.optional(types.array(GLAccount), []),
  glAccountsStored: types.optional(types.array(GLAccount), []),
  utilityGlAccounts: types.optional(types.array(UtilityGlAccountsUnit), []),
  utilityGlAccountsStored: types.optional(types.array(UtilityGlAccountsUnit), []),
  rentGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  adminFeeGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  paperStatementFeeGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  accountSetupFeeGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  glAccountExternalId: types.optional(types.maybeNull(types.string), null),
  //default
  accountsPayableGlAccountExternalId: types.optional(types.maybeNull(types.string), null),
  chargeOnDayOfMonth: types.optional(types.maybeNull(types.number), null)
}).views(store => ({
  utilityGlAccountsPatchSemanticallyEqual() {
    const norm = arr => [...toJS(arr)].map(i => {
      var _i$propertyUtilityLiv, _i$glAccountExternalI, _i$accountsPayableGlA;
      return {
        id: (_i$propertyUtilityLiv = i.propertyUtilityLivableId) !== null && _i$propertyUtilityLiv !== void 0 ? _i$propertyUtilityLiv : '',
        gl: (_i$glAccountExternalI = i.glAccountExternalId) !== null && _i$glAccountExternalI !== void 0 ? _i$glAccountExternalI : null,
        payableGl: (_i$accountsPayableGlA = i.accountsPayableGlAccountExternalId) !== null && _i$accountsPayableGlA !== void 0 ? _i$accountsPayableGlA : null
      };
    }).sort((a, b) => a.id.localeCompare(b.id));
    return JSON.stringify(norm(store.utilityGlAccountsStored)) === JSON.stringify(norm(store.utilityGlAccounts));
  },
  getUtilityGlAccountsValueForPatch() {
    const prevArr = toJS(store.utilityGlAccountsStored);
    const currArr = toJS(store.utilityGlAccounts);
    const prevMap = new Map(prevArr.map(i => [i.propertyUtilityLivableId, i]));
    const prevIds = new Set(prevArr.map(i => i.propertyUtilityLivableId).filter(Boolean));
    const currIds = new Set(currArr.map(i => i.propertyUtilityLivableId).filter(Boolean));
    const hadRemoval = [...prevIds].some(id => !currIds.has(id));
    const delta = currArr.filter(c => {
      var _prev$glAccountExtern, _c$glAccountExternalI, _prev$accountsPayable, _c$accountsPayableGlA;
      const prev = prevMap.get(c.propertyUtilityLivableId);
      return ((_prev$glAccountExtern = prev === null || prev === void 0 ? void 0 : prev.glAccountExternalId) !== null && _prev$glAccountExtern !== void 0 ? _prev$glAccountExtern : null) !== ((_c$glAccountExternalI = c.glAccountExternalId) !== null && _c$glAccountExternalI !== void 0 ? _c$glAccountExternalI : null) || ((_prev$accountsPayable = prev === null || prev === void 0 ? void 0 : prev.accountsPayableGlAccountExternalId) !== null && _prev$accountsPayable !== void 0 ? _prev$accountsPayable : null) !== ((_c$accountsPayableGlA = c.accountsPayableGlAccountExternalId) !== null && _c$accountsPayableGlA !== void 0 ? _c$accountsPayableGlA : null);
    });
    if (hadRemoval) {
      return currArr;
    }
    return delta.length ? delta : currArr;
  },
  // BE rejects a null glAccountExternalId, so entries touched only through the payable GL
  // still have to carry the property-level default.
  normalizeUtilityGlAccountsForPatch(list) {
    return list.map(i => _objectSpread(_objectSpread({}, i), {}, {
      glAccountExternalId: i.glAccountExternalId || store.glAccountExternalId || null
    }));
  }
})).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setGlAccounts(data) {
      try {
        store.glAccounts = data;
        store.glAccountsStored = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    searchGlAccounts(searchValue) {
      try {
        const searchResp = [];
        store.glAccountsStored.map(i => {
          if (i.name.toLocaleLowerCase().includes(searchValue.trim().toLocaleLowerCase())) {
            searchResp.push(toJS(i));
          }
        });
        store.glAccounts = searchResp;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleGlSelectClose() {
      try {
        store.glAccounts = toJS(store.glAccountsStored);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setGlCodesAfterLoad(data) {
      try {
        Object.entries(data).forEach(_ref => {
          let _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          store[key] = value;
          if (key === 'utilityGlAccounts') {
            store.utilityGlAccountsStored = value;
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateGlCode(type, value) {
      try {
        store[type] = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateUtilityGlAccounts(utilityId, glId) {
      try {
        const idx = store.utilityGlAccounts.findIndex(i => i.propertyUtilityLivableId === utilityId);
        if (idx !== -1) {
          store.utilityGlAccounts[idx].glAccountExternalId = glId;
        } else {
          store.utilityGlAccounts.push({
            propertyUtilityLivableId: utilityId,
            glAccountExternalId: glId,
            accountsPayableGlAccountExternalId: null
          });
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateUtilityAccountsPayableGlAccounts(utilityId, glId) {
      try {
        const idx = store.utilityGlAccounts.findIndex(i => i.propertyUtilityLivableId === utilityId);
        if (idx !== -1) {
          store.utilityGlAccounts[idx].accountsPayableGlAccountExternalId = glId;
        } else {
          store.utilityGlAccounts.push({
            propertyUtilityLivableId: utilityId,
            glAccountExternalId: store.glAccountExternalId,
            accountsPayableGlAccountExternalId: glId
          });
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleUtilityGlAccountsClose() {
      try {
        store.utilityGlAccounts = toJS(store.utilityGlAccountsStored);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    handleUtilityGlAccountsSave() {
      try {
        store.utilityGlAccountsStored = toJS(store.utilityGlAccounts);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getGlNameByCode(code) {
      try {
        const glName = store.glAccountsStored.find(i => i.externalId === code);
        return glName && glName.name ? glName.name : 'N/A';
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});